// src/app/views/pages_predict_admin/set_exam/rtPrAdSetExam.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const SetExam = Loadable(lazy(() => import("./SetExam")));

const rtPrAd = [
  { path: `pre/${EXAM_TYPES.LEET.rid_cd_ext}/set-exam`, element: <SetExam /> },
  { path: `pre/${EXAM_TYPES.G5.rid_cd_ext}/set-exam`, element: <SetExam /> },
  { path: `pre/${EXAM_TYPES.G7.rid_cd_ext}/set-exam`, element: <SetExam /> },
];
export default rtPrAd;
